/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.carousel = {
    attach: function (context) {
      $(document).ready(function(){

        $('.slick-carousel').once('carousel-processed').addClass("carousel-processed").each(function () {
          var options = $(this).data("carousel");

          var itemSize = null;
          if (options.itemSize == 'none') {
            itemSize = [];
          }
          else if (options.itemSize == 'small') {
            itemSize = [
              { breakpoint: 1150, settings: { slidesToShow: 2 } },
              { breakpoint: 900, settings: { slidesToShow: 1 } },
            ];
          }
          else if (options.itemSize == 'big') {
            itemSize = [
              { breakpoint: 1250, settings: { slidesToShow: 3 } },
              { breakpoint: 900, settings: { slidesToShow: 2 } },
              { breakpoint: 600, settings: { slidesToShow: 1 } },
            ];
          }
          else if (options.itemSize == 'side-info') {
            itemSize = [
              { breakpoint: 1350, settings: { slidesToShow: 2 } },
              { breakpoint: 1000, settings: { slidesToShow: 1 } },
            ];
          }

          $(this).slick({
            dots: options.nav,
            infinite: options.loop,
            speed: 300,
            rows: 0,
            autoplay: false,
            slidesToShow: options.items,
            slidesToScroll: options.slideBy,
            prevArrow: '<button type="button" class="slick-prev">'  + options.controlsText[0] + '</button>',
            nextArrow: '<button type="button" class="slick-next">'  + options.controlsText[1] + '</button>',
            draggable: true,
            responsive: itemSize,
          });
        });

        $('.slick-filter').once('filter-processed').addClass("filter-processed").each(function () {
          $(this).on('click',function(){
            var $slick = $(this).closest('.carousel').find('.slick-carousel');
            var $filters = $(this).closest('.carousel').find('.slick-filter');
            var $href = $(this).attr('href');
            var $class = $href.slice(1);

            $slick.slick('slickUnfilter');

            if ( $(this).hasClass('active') ) {
              $filters.removeClass('active');
            }
            else {
              $slick.slick('slickFilter', '.' + $class);
              $filters.removeClass('active');
              $(this).addClass('active');
            }

          });
        });

      });
    }
  }
})(Drupal, jQuery);
